export default __webpack_public_path__ + "static/media/VTECHs.f9576ada.png";